// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ParticipantAgentBatchOperations } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Batch/ParticipantAgentV1';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const useParticipantAgentBatchOperations: () => UseQueryResult<
  TemplateContract<ParticipantAgentBatchOperations>[],
  string
> = () =>
  useOperatorBasedQuery('queryParticipantAgentBatchOperations', (ledgerApi, offset, operator) =>
    ledgerApi.queryParticipantAgentBatchOperations(offset, operator),
  );

export default useParticipantAgentBatchOperations;
